import { render, staticRenderFns } from "./viewDprReason.vue?vue&type=template&id=7d488f17&"
import script from "./viewDprReason.vue?vue&type=script&lang=js&"
export * from "./viewDprReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports